/** @module Apparel/MaterialSamplesForm */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Field",
	"csi/form/Widget"
], function(declare, lang, def, Field, Widget) {

	return declare(Widget, {
		COPY_SAMPLE_BOM: "CopySampleBOM",

		_resolveView: function() {
			if (this.isCopy()) {
				this.insertField(lang.mixin(new Field(), {
					m_label: this.COPY_SAMPLE_BOM,
					m_typeControl: def.FIELD_CHECKBOX
				}));

				if (this.urlRoot && this.cacheView.getNode(this.urlRoot).SampleDataSheets.length > 0) {
					this.addDefaultValue(this.COPY_SAMPLE_BOM, true);
				} else {
					this.addFixedValue(this.COPY_SAMPLE_BOM, false);
				}
			}

			// SampleStorage is a reverse relationship of a refmap without an aggregate store, so we cannot properly add the sample to the map; skip for now
			// this can be removed after implementing C8-55914
			const sampleStorageField = this.getField("SampleStorage");
			if (sampleStorageField) {
				sampleStorageField.omitFromReport = true;
			}

			this.inherited(arguments);
		}
	});
});